.FSButton {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--primitives-colors-neutral-0);
  font: var(--font-caption-lg-medium);
  text-shadow: var(--semantic-colors-typography-inverse) 1px 0 5px;
  text-align: center;
}